import createApi from './api';

export default class PredictionsSettingsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/predictions',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async getPredictionsBuffers() {
    return this.api.get('get-buffer');
  }

  async updatePredictionsBuffers(params) {
    return this.api.post('set-buffer', params);
  }
}
